import { render, staticRenderFns } from "./PartDebtors.vue?vue&type=template&id=645c35bf"
import script from "./PartDebtors.vue?vue&type=script&lang=js"
export * from "./PartDebtors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports